import { INemsisFilterFields } from '../../../../components/procedure/store/procedure.types'
import { GenericField } from '../../../../utilities/object.util'
import { ICardiacState } from '../store/cardiac.types'

export const getCardiacFilters = (cardiacState: ICardiacState): INemsisFilterFields<ICardiacState> => {
  let filter1Field: GenericField<ICardiacState> = null
  let filter2Field: GenericField<ICardiacState> = null
  let filter3Field: GenericField<ICardiacState> = null

  switch (cardiacState.action?.name) {
    case 'Cardioversion':
      filter1Field = null
      filter2Field = (s) => s.joules.toString()
      filter3Field = (s: ICardiacState) => s.waveformType?.id?.toString()
      break

    case 'Defibrillation':
      filter1Field = (s: ICardiacState) => s.defibType?.id?.toString()
      filter2Field = (s: ICardiacState) => s.joules.toString()
      filter3Field = (s: ICardiacState) => s.waveformType?.id?.toString()
      break

    case 'External Pacing':
    case 'Internal Pacing':
      filter1Field = 'heartRate'
      filter2Field = (s: ICardiacState) => s.mA.toString()
      filter3Field = (s: ICardiacState) => s.pacingMode?.id?.toString()
      break

    case '12-Lead EKG':
    case '12-Lead EKG - Transmitted':
    case '15-Lead EKG':
    case '18-Lead EKG':
    case 'CPR':
    case 'CPR AED':
    case 'Cardiac Monitor':
    case 'Cartoid Massage':
    case 'Chilled Saline Administration':
    case 'Defibrillator Pad Application':
    case 'Mechanical CPR':
    case 'Patient Cooling - Post Resuscitation':
    case 'Precordial Thump':
    case 'Vagal Maneuver':
    default:
      filter1Field = null
      filter2Field = null
      filter3Field = null
      break
  }

  return {
    filter1Field,
    filter2Field,
    filter3Field,
  }
}
